import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './DesktopHeaderNewAdBtn.styles';
import { CommonTestIds } from '@/__e2e__/testIds/common';
import { ROUTES } from '@/constants/routes';
import { IconBox } from '@/components/UI/IconBox/IconBox.styles';

interface DesktopHeaderNewAdBtnProps {
  onClick: () => void;
}

export const DesktopHeaderNewAdBtn = ({
  onClick,
}: DesktopHeaderNewAdBtnProps) => {
  const { t } = useTranslation();

  return (
    <S.DesktopNewAdBtnBox
      id="new_ad_link"
      dataTestId={CommonTestIds.desktopHeader.newAdButton}
      href={ROUTES.newAd}
      onClick={onClick}
    >
      <S.DesktopNewAdBtn>
        <IconBox
          $filename="new-ad.svg"
          $width={17}
          $height={17}
          $iconHeight={17}
          $iconWidth={17}
        />
        <span>{t('common.new_ad')}</span>
      </S.DesktopNewAdBtn>
    </S.DesktopNewAdBtnBox>
  );
};
